import { useMutation } from '@apollo/client';

import setUserPhotoMutation from '../../requests/mutations/setUserPhoto';
import changeUserDataMutation from '../../requests/mutations/changeUserData';
import updateMobileMutation from '../../requests/mutations/updateMobile';
import updateEmailMutation from '../../requests/mutations/updateEmail';

export function useChangeUserDataMutation(fn) {
  const [changeUserData] = useMutation(changeUserDataMutation, {
    onCompleted: () => fn && fn()
  });

  return changeUserData;
}

export function useSetUserPhotoMutation(fn) {
  const [setUserPhoto] = useMutation(setUserPhotoMutation, {
    onCompleted: () => fn && fn()
  });

  return setUserPhoto;
}

export function useUpdateMobileMutation(fn) {
  const [updateMobile] = useMutation(updateMobileMutation, {
    onCompleted: () => fn && fn()
  });

  return updateMobile;
}

export function useUpdateEmailMutation(fn) {
  const [updateEmail] = useMutation(updateEmailMutation, {
    onCompleted: () => fn && fn()
  });

  return updateEmail;
}
